var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-3" },
    _vm._l(_vm.model.areas, function(item) {
      return _c(
        "div",
        { key: item.area.id },
        [
          _c("answer", {
            attrs: { "is-read-only": _vm.isReadOnly, value: item },
            on: {
              input: function($event) {
                return _vm.onAnswer(item, $event)
              }
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }